import React, { useEffect, useRef } from 'react';
import { createSafeResizeObserver } from '@shared/utils/createSafeResizeObserver';
import type { SafeResizeObserver } from '@shared/utils/createSafeResizeObserver';
import { useIsMounted } from '../../common';

type ResizeSensorProps = Readonly<{
  children: React.ReactNode;
  onResize: () => void;
}>;

export const ResizeSensor: React.FC<ResizeSensorProps> = props => {
  const nodeRef = useRef<HTMLDivElement | null>(null);
  const isMounted = useIsMounted();
  useEffect(() => {
    if (!isMounted) {
      return;
    }

    const ro: SafeResizeObserver = createSafeResizeObserver(() => {
      props.onResize();
    });

    if (nodeRef.current) {
      ro.observe(nodeRef.current);
    }

    return () => {
      ro.disconnect();
    };
  }, [isMounted]);

  const { children } = props;
  return <div ref={nodeRef}>{children}</div>;
};

ResizeSensor.displayName = 'ResizeSensor';
